const ProfileCompletionSkeleton = () => (
    <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl p-6 shadow-xl relative overflow-hidden animate-pulse">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>
        <div className="relative z-10">
            <div className="flex items-start space-x-4">
                <div className="p-3 bg-white/20 rounded-xl w-12 h-12"></div>
                <div className="flex-1 space-y-2">
                    <div className="h-5 bg-white/30 rounded w-3/4"></div>
                    <div className="h-4 bg-white/20 rounded w-full"></div>
                </div>
            </div>
            <div className="mt-6">
                <div className="w-full bg-white/20 rounded-full h-3"></div>
                <div className="flex items-center justify-between mt-3">
                    <div className="h-4 bg-white/20 rounded w-1/3"></div>
                    <div className="h-5 bg-white/30 rounded w-1/4"></div>
                </div>
            </div>
            <div className="bg-white/30 h-12 rounded-lg w-full mt-6"></div>
        </div>
    </div>
);

export default ProfileCompletionSkeleton;